import React from 'react'

import CustomerDetails from './CustomerDetails';
import InfoSection from './InfoSection';

const ConfirmationPage = () => {
  return (
    <>
      <CustomerDetails/>
      <InfoSection/>
    </>
  )
}

export default ConfirmationPage
